import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import style from './ItemContent.css'

/**
 * Item Content holds the textual content of an [Item](/components/item/),
 * typically an [Item Title](/components/item-title/) and an
 * [Item Description](/components/item-description/). It grows to fill the
 * available space.
 *
 * @status draft
 * @category list
 * @lightDom true
 *
 * @slot - Default slot for the content, such as a title and description.
 */
@customElement('nord-item-content')
export default class ItemContent extends LitElement {
  connectedCallback() {
    super.connectedCallback()
    injectLegacyLightDomStyles(this, style)
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-item-content': ItemContent
  }
}
